import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGoogleRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9992 8.74984C17.7692 8.74984 19.3542 9.35984 20.6042 10.5498L24.0292 7.12485C21.9492 5.18987 19.2342 3.99988 15.9992 3.99988C11.3093 3.99988 7.25428 6.68986 5.2793 10.6098L9.26927 13.7048C10.2143 10.8598 12.8692 8.74984 15.9992 8.74984Z",
			fill: "#EA4335"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.4899 16.2748C27.4899 15.4898 27.4149 14.7298 27.2999 13.9998H16V18.5098H22.47C22.18 19.9898 21.34 21.2498 20.08 22.0998L23.9449 25.0997C26.1999 23.0098 27.4899 19.9198 27.4899 16.2748Z",
			fill: "#4285F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.26496 18.2941C9.02496 17.5691 8.88496 16.7991 8.88496 15.9992C8.88496 15.1992 9.01996 14.4292 9.26496 13.7042L5.27499 10.6092C4.46 12.2292 4 14.0592 4 15.9992C4 17.9391 4.46 19.7691 5.27999 21.3891L9.26496 18.2941Z",
			fill: "#FBBC05"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.0003 27.9999C19.2403 27.9999 21.9653 26.9349 23.9453 25.0949L20.0803 22.0949C19.0053 22.8199 17.6203 23.2449 16.0003 23.2449C12.8703 23.2449 10.2154 21.135 9.26536 18.29L5.27539 21.385C7.25538 25.3099 11.3103 27.9999 16.0003 27.9999Z",
			fill: "#34A853"
		})
	]
});
export default SvgGoogleRegularIcon;
